import React from 'react';
import IconButton from "../../../../components/Button/IconButton";
import SvgNew from "../../../../components/SvgNew";

const ButtonPallets = ({onClick, isSelected}) => {
    return (
        <IconButton
            text={'Паллеты'}
            icon={<SvgNew name='pallets'/>}
            isSelected={isSelected}
            info={{
                label: '',
                name: 'Паллеты',
                text: 'Товар находится на евро паллетах размером 80см Х 120см, высота паллеты до 2 метров',
                position: 'right',
                offset: [10]
            }}
            onClick={onClick}
        />
    );
};

export default ButtonPallets;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/buttons/buttonPallets.jsx